import { render, staticRenderFns } from "./PortalHistoryMenus.vue?vue&type=template&id=2ae2f25d&scoped=true&"
import script from "./PortalHistoryMenus.vue?vue&type=script&lang=ts&"
export * from "./PortalHistoryMenus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae2f25d",
  null
  
)

export default component.exports